export default __webpack_public_path__ + "static/media/user-type-player-agent.6492ee05.svg";